import React, { useState } from "react";
import { FiChevronDown } from "react-icons/fi";

const CollapsableTagView = ({ icon, tagHeader, tagList, itemRenderer }) => {
    const [dropdown, setDropdown] = useState(true);
    return (
        <div
            className={`cursor-pointer duration-150 -mt-4 ${
                !dropdown ? "mb-8" : ""
            }`}
        >
            <div
                className="flex bg-kadItemDarkBg items-center border rounded-lg md:rounded-full py-4 px-6 duration-150 border-kadComponentBg translate-y-1/2"
                onClick={() => {
                    setDropdown((dropdown) => !dropdown);
                }}
            >
                {icon}
                <span className="ml-4">{tagHeader}</span>
                <FiChevronDown
                    className={`ml-auto duration-150 ${
                        dropdown ? "-scale-y-100" : ""
                    }`}
                />
            </div>
            <div
                className={`w-full md:border border-kadComponentBg md:rounded-b-2xl duration-300 overflow-y-scroll ${
                    dropdown ? "max-h-[360px]" : "max-h-0"
                }`}
            >
                <div className="grid grid-cols-3 gap-3 pt-10 md:pt-14 md:p-8">
                    {tagList.map((item, i) => itemRenderer(item, i))}
                </div>
            </div>
        </div>
    );
};
export default CollapsableTagView;
